import { post, get, downloadBlob } from './client';
import { makeGrowerPath } from './utils';

export function runFungicide(aaids, props) {
  return post(makeGrowerPath(`/early-season-fungicide/run`), {
    aaids,
    ...props,
  });
}

export function getFungicideFields(growerId) {
  return get(`/early-season-fungicide/by-grower/${growerId}`);
}

export function getFungicideStats(aaid) {
  return get(makeGrowerPath(`/early-season-fungicide/stats/${aaid}`));
}

export function getFungicidePreview(aaid, product, adjustments) {
  return post(
    makeGrowerPath(`/early-season-fungicide/stats/${aaid}/${product}/preview`),
    adjustments,
  );
}

export function saveFungicideAdjustments(aaid, product, adjustments) {
  return post(
    makeGrowerPath(`/early-season-fungicide/adjustments/${aaid}/${product}`),
    adjustments,
  );
}

export function downloadEarlySeasonFungicideShapefile(growerId, aaids) {
  return downloadBlob(`/fungicide/${growerId}/shapefile`, aaids);
}

export function downloadEarlySeasonFungicidePdfs(growerId, aaids) {
  return downloadBlob(`/fungicide/${growerId}/pdf`, aaids);
}
